/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Create_HintInputs */

const cs_settings_teams_create_hint = /** @type {(inputs: Settings_Teams_Create_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedoucí se automaticky přidá mezi členy.`)
};

const en_settings_teams_create_hint = /** @type {(inputs: Settings_Teams_Create_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The leader is added as a member automatically.`)
};

/**
* | output |
* | --- |
* | "The leader is added as a member automatically." |
*
* @param {Settings_Teams_Create_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_create_hint = /** @type {((inputs?: Settings_Teams_Create_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Create_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_create_hint(inputs)
	return cs_settings_teams_create_hint(inputs)
});